import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import Button from "components/Button";
import TextInput from "components/TextInput";
import ERoutes from "types/Routes";
import styles from "./styles.module.scss";
import axiosInstance from "services/axiosInstance";
import { ENDPOINTS } from "api/endpoints";

const changePasswordSchema = yup.object().shape({
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords don't match")
    .required("Confirm New Password is required"),
  password: yup
    .string()
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&]).{8,}$/,
      "Requires alpha-numeric(a-Z & 0-9) and special characters(@$!%*#?&)",
    )
    .required("New Password is required"),
});

interface IFormChangePassword {
  confirmPassword: string;
  password: string;
}

const ChangePassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const normalizedUrl = location.pathname.endsWith("/")
    ? location.pathname
    : location.pathname + "/";
  const [searchParams] = useSearchParams(normalizedUrl);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<IFormChangePassword>({
    resolver: yupResolver(changePasswordSchema),
  });

  const onSubmit = async (formData: IFormChangePassword) => {
    try {
        
        const changePassword = axiosInstance.post(ENDPOINTS.CHANGE_PASSWORD, {
            token: searchParams.get("token") || "",
            password: formData.password,
        })
        
        if ((await changePassword).status === 201) {
            toast.success("Password changed successfully");
            navigate(ERoutes.Login, { replace: true });
        } else {
            toast.error("Something went wrong. Please contact your admin");
        }

    } catch {
      toast.error("Something went wrong. Please contact your admin");
    }
  };

  return (
    <>
      <div className={styles.background} />
      <div className={styles.createUser}>
        <div className={styles["createUser__banner"]}>
          <img src="/assets/images/logo-bright.svg" alt="logo" width="137px" />
          <h1>Almost there!</h1>
          <p>Finish setting your new password to access VinDrives</p>
        </div>
        <form
          className={styles["createUser__form"]}
          onSubmit={handleSubmit(onSubmit)}
        >
          <TextInput
            disabled={isSubmitting}
            errorMessage={errors.password?.message as string}
            label="New Password"
            name="password"
            register={register}
            type="password"
          />

          <TextInput
            disabled={isSubmitting}
            errorMessage={errors.confirmPassword?.message as string}
            label="Confirm New Password"
            name="confirmPassword"
            register={register}
            type="password"
          />

          <Button size="lg" disabled={isSubmitting}>
            Add
          </Button>
        </form>
      </div>
    </>
  );
};

export default ChangePassword;
